export interface FrontendConfig {
  backend: {
    baseUrl: string;
  };
  frontend: {
    baseUrl: string;
    dashboardUrl: string;
  };
  stripe: {
    publicKey: string;
  };
}

export const getFrontendConfig = (): FrontendConfig => {
  const isDevelopment = import.meta.env.DEV;
  const isLocalhost =
    typeof window !== "undefined" && window.location.hostname === "localhost";

  if (isDevelopment || isLocalhost) {
    // Local development configuration
    return {
      backend: {
        baseUrl: "http://localhost:3001",
      },
      frontend: {
        baseUrl: "http://localhost:8000",
        dashboardUrl: "/dashboard",
      },
      stripe: {
        publicKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || "",
      },
    };
  }

  // Production configuration
  return {
    backend: {
      baseUrl: "https://buy.multiagentbook.com",
    },
    frontend: {
      baseUrl: "https://buy.multiagentbook.com",
      dashboardUrl: "/dashboard",
    },
    stripe: {
      publicKey: process.env.GATSBY_STRIPE_PUBLISHABLE_KEY || "",
    },
  };
};

export const FRONTEND_CONFIG = getFrontendConfig();
